import React, { useState, useEffect, useRef } from 'react'
import config from '../config.json';
import { stringify } from 'query-string';
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';
import { Checkbox, Popover, FormControlLabel, Button, CircularProgress } from '@material-ui/core';
import greenDownArrow from '../images/green_down_arrow.svg'
import blueDownArrow from '../images/blue_down_arrow.svg'
import greySearchIcon from '../images/grey_search_icon.svg'


export default function CustomRowFilter(props) {
    const { filterTypesInitState, filterListValue, setFilterListValue, pathName, defaultColumns, storageKey, setDisplayColumns } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let stateAfterFilter = filterTypesInitState.filter((val) => val.showFilter)
        .map((val) => {
            if (val.listType === 'Static') {
                if (val.filterType === 'Vehicle') {
                    if (sessionStorage.getItem("vehicle_types") !== "null" && sessionStorage.getItem("vehicle_types") != null) {
                        return { ...val, dataList: val.dataList.filter(item => JSON.parse(sessionStorage.getItem("vehicle_types")).includes(item.id)) }
                    }
                    else return val
                } else return { ...val, dataList: val.dataList.filter(item => item.show !== false) }
            }
            return val
        }).map((val) => {
            return { ...val, value: "", id: "" }
        })

    const [resultList, setResultList] = useState(stateAfterFilter);
    const [loading, setLoading] = useState(false)
    const [checkedItems, setCheckedItems] = useState([]);
    const [currentlyOpened, setCurrentlyOpened] = useState(null)
    const [displayColumnsDefaultValue, setDisplayColumnsDefaultValue] = useState(defaultColumns)
    const [searchText, setSearchText] = useState("");
    const [currentIndex, setCurrentIndex] = useState(null)
    const [noData, setNoData] = useState(false)
    const searchRef = useRef(null);
    const toggleColumnVisibility = column => {
        setDisplayColumnsDefaultValue(dc => {
            const temp = { ...dc };
            temp[column] = !temp[column];
            setDisplayColumns(temp)
            localStorage.setItem(storageKey, JSON.stringify(temp));
            return temp;
        });
    };

    const handleClose = () => {
        setAnchorEl(null);
        setCurrentlyOpened(null)
    };

    const onFilterClick = (event, filterFormat, dataList, index, v) => {
        setCheckedItems([])
        setCurrentIndex(index)
        if (resultList[index].filterType === "Display Columns") {
            setCheckedItems(Object.keys(displayColumnsDefaultValue).map((val) => { return { checked: displayColumnsDefaultValue[val], index: index, name: val } }))
            return
        }
        if (filterFormat === 'Checkbox') {
            if (resultList[index].listType === "Dynamic"){
                setSearchText("")
                const active = resultList[index].dataList.filter((val) => val.checked === true)
                if(!active[0]) fetchDynamicFilterData(index)
                else {
                    setCheckedItems(resultList[index].dataList)
                    setCurrentlyOpened(resultList[index].filterType)
                }
            } 
            else {
                setCheckedItems(dataList.map((val) => { return { checked: false, index: index, ...val } }))
                setCurrentlyOpened(resultList[index].filterType)
            }

        } else {
            setResultList(resultList => {
                let copy = [...resultList]
                let copyItem = { ...copy[index] }
                let updateList = copyItem.dataList.map((val) => {
                    if (val.name === v.name) {
                        if (val.checked === true) {
                            copyItem.id = ""
                            copyItem.value = ""
                            return { ...val, checked: false }
                        }
                        copyItem.id = val.id
                        copyItem.value = val.name
                        return { ...val, checked: true }
                    }
                    else return { ...val, checked: false }
                })
                copy[index] = { ...copyItem, dataList: updateList }
                setFilterListValue(copy.map(({ filterType, value, id }) => {
                    return { filterType, value, id }
                })
                )
                if (sessionStorage.getItem(pathName)) {
                    let prevdata = JSON.parse(sessionStorage.getItem(pathName))
                    sessionStorage.setItem(`${pathName}`, JSON.stringify({ ...prevdata, radioValue: copy }))
                } else {
                    sessionStorage.setItem(`${pathName}`, JSON.stringify({ radioValue: copy }))
                }
                return copy
            })
        }

        setAnchorEl(event.currentTarget);
    }

    const fetchDynamicFilterData = (index) => {
        const token = sessionStorage.getItem('token');
        const perPage = 15
        if (token != null && token !== "") {
            setLoading(true)
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ [resultList[index].resourceParam ? resultList[index].resourceParam : resultList[index].source]: searchText, ...resultList[index].filterParams }),
                sort: JSON.stringify(["name", "ASC"]),
                page: 1,
                perPage
            }
            fetch(`${config.HOST_NAME}/crm/v3/${resultList[index].resourcePath}?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    if (responseJson.success && responseJson.data) {
                        setNoData(searchText && responseJson.data && !responseJson.data[0])
                        const copy = [...resultList]
                        const checkedOptions = resultList[index].dataList.filter((val) => val.checked === true).map((val) => { return {...val } })
                        if(searchText && responseJson.data && responseJson.data[0]) copy[index].dataList = [...responseJson.data.map((val) => { return { checked: false, index: index, ...val } })]
                        else copy[index].dataList = [...responseJson.data.map((val) => { return { checked: false, index: index, ...val } })]
                        
                        if(checkedOptions[0]) {
                            const values = checkedOptions.map((val) => val.id)
                            const filterDuplicateSelectedValues = copy[index].dataList.filter((val) => !values.includes(val.id))
                            copy[index].dataList = [...checkedOptions, ...filterDuplicateSelectedValues]
                        }

                        setCheckedItems(copy[index].dataList)
                        setCurrentlyOpened(resultList[index].filterType)
                    }
                    else notify(responseJson.message, 'warning');
                })
                .catch((e) => {
                    notify('Error fetching data', 'warning');
                    console.log(e);
                })
                .finally(() => {
                    setLoading(false)
                })
        }
    }

    const handleCheckboxChange = (index) => {
        setCheckedItems((prevItems) => {
            const newItems = [...prevItems];
            newItems[index].checked = !newItems[index].checked;
            if (resultList[currentIndex].filterType === "Display Columns") toggleColumnVisibility(newItems[index].name)
            return newItems;
        });

    };

    const applyFilter = () => {
        setResultList(resultList => {
            const currentlyIndex = checkedItems[0].index
            let copy = [...resultList]
            let copyItem = { ...copy[currentlyIndex] }
            copyItem.value = checkedItems.filter((val) => val.checked).map((val) => val.name)
            if (Array.isArray(copyItem.value) && !copyItem.value[0]) copyItem.value = ""
            copy[currentlyIndex] = { ...copyItem }
            setFilterListValue(copy.map(({ filterType, value, id }) => {
                return { filterType, value, id }
            })
            )
            if (sessionStorage.getItem(pathName)) {
                let prevdata = JSON.parse(sessionStorage.getItem(pathName))
                sessionStorage.setItem(`${pathName}`, JSON.stringify({ ...prevdata, radioValue: copy }))
            } else {
                sessionStorage.setItem(`${pathName}`, JSON.stringify({ radioValue: copy }))
            }
            return copy
        })
        handleClose()
    }

    const clearFilter = () => {
        setCheckedItems((prev) => {
            return prev.map((val) => { return { ...val, checked: false } })
        })
    }

    useEffect(() => {
        if (filterListValue) {
            setResultList((resultList) => {
                const copy = [...resultList]
                return copy.map((val, index) => {
                    if (!val.filterFormat) {
                        return {
                            ...val, dataList: val.dataList.map((v) => {
                                if (v.name === filterListValue[index].value) {
                                    return { ...v, checked: true }
                                } else return { ...v, checked: false }
                            })
                        }
                    } else {
                        return {
                            ...val, dataList: val.dataList.map((v) => {
                                if (filterListValue[index].value.includes(v.name)) {
                                    return { ...v, checked: true }
                                } else return { ...v, checked: false }
                            })
                        }
                    }
                })
            })
        }
    }, [filterListValue])

    useEffect(() => {
        if (searchRef.current)
            clearTimeout(searchRef.current);
        if (currentIndex) searchRef.current = setTimeout(() => fetchDynamicFilterData(currentIndex), 800)
    }, [searchText]);  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div className='rowFilterScroll' style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: 10 }}>
                <div style={{ marginTop: 10 }}>
                    {resultList.map((val, index) => {
                        const dataList = val.dataList
                        const filterType = val.filterType
                        const filterFormat = val.filterFormat
                        const active = dataList.filter((val) => val.checked === true)
                        const activeCount = Array.isArray(active) && active[0] ? active.length : null
                        const filters = !filterFormat || filterFormat === "Text" || filterType === "Display Columns" ? val.dataList.filter((val) => val.filterFormat).map((val, i) => {
                            const filterName = val.name
                            return <Button key={i} onClick={(e) => onFilterClick(e, filterFormat, dataList, index, val)} style={{ position: "relative", zIndex: currentlyOpened ? 1400 : 0, backgroundColor: "#F5F8FA", border: val.checked ? "1px solid #18cc69" : "", padding: "5px 15px", borderRadius: 5, marginRight: 10 }}>
                                <div style={{ fontSize: "10px", color: "#90A0B7" }}>{filterType}</div>
                                <div className='fontWeightSemiBold' style={{ fontSize: "12px", color: "#334D6E" }}>{filterName}</div>
                            </Button>
                        }) : <Button aria-describedby={id} key={index} onClick={(e) => onFilterClick(e, filterFormat, dataList, index)} style={{ position: "relative", textTransform: "none", zIndex: currentlyOpened ? 1400 : 0, fontWeight: 500, backgroundColor: active[0] ? "#18CC6919" : "#F5F8FA", border: active[0] || currentlyOpened === filterType ? "1px solid #18cc69" : "1px solid #EFEFEF", padding: "8px", borderRadius: 4, marginRight: 10 }}>
                            {/* <div style={{ fontSize: "10px", color: "#90A0B7" }}>Select</div> */}
                            <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                <div className='fontWeightMedium' style={{ fontSize: "12px", color: active[0] ? "#18CC69" : "#334D6E", marginRight: 5 }}>{filterType} {activeCount && `(${activeCount})`}</div>
                                <img src={active[0] ? greenDownArrow : blueDownArrow} width={12} height={15} alt='Arrow' style={{ marginTop: 2 }} />
                            </div>
                        </Button>
                        return filters
                    })}
                </div>
            </div>

            {checkedItems &&
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    elevation={2}
                >
                    <div style={{ position: "relative", minWidth: 250 }}>
                        {currentIndex && resultList[currentIndex].showSearchBar ?
                            <div style={{ padding: "8px 16px", top: 0, zIndex: 10, borderBottom: "1px solid #DCDCDC", backgroundColor: "#FFF", width: "100%" }}>
                                <div className='rowFilterSearchBar' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <img src={greySearchIcon} width={12} height={15} alt='Arrow' style={{ marginRight: 4 }} />
                                    <input className='rowFilterInput'
                                        type="text"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder='Search'
                                    />
                                </div>
                            </div> 
                            : null
                        }
                        <div style={{ padding: "0px 16px 50px 16px", display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", height: 200, overflow: "auto", overflowX: "hidden" }}>
                            {!noData && checkedItems.map((item, index) => (
                                <FormControlLabel
                                    checked={item.checked}
                                    onChange={e => handleCheckboxChange(index)}
                                    control={<Checkbox />}
                                    label={<span style={{ color: "#3D3D3D", fontSize: 14 }}>{item.name}</span>}
                                />
                            ))}
                            {(checkedItems.length === 0 || noData) && !loading && <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", color: "#3D3D3D", fontSize: 14 }}>No Data Found.</div>}
                            {loading && <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}><CircularProgress size={20} style={{ color: "#18CC69" }} /></div>}
                        </div>
                        <div style={{ padding: "8px 16px", position: "absolute", bottom: 0, zIndex: 10, borderTop: "1px solid #DCDCDC", backgroundColor: "#FFF", width: "100%" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "87%" }}>
                                <Button
                                    className='addBorderRadius'
                                    onClick={() => clearFilter()}
                                    color="primary"
                                    variant="contained"
                                    style={{ textTransform: "none", fontSize: 14, fontFamily: "Poppins-Regular", fontWeight: 500, letterSpacing: "0.06em", height: "36px", backgroundColor: "#FFF", color: "#7C7C7C" }}
                                    disableElevation

                                >
                                    Clear All
                                </Button>
                                <Button
                                    className='addBorderRadius'
                                    onClick={() => applyFilter()}
                                    color="primary"
                                    variant="contained"
                                    style={{ flex: 1, textTransform: "none", fontSize: 14, fontFamily: "Poppins-Regular", fontWeight: 500, letterSpacing: "0.06em", height: "36px", backgroundColor: "#18CC69", color: "#FFF" }}
                                    disableElevation

                                >
                                    Apply
                                </Button>
                            </div>
                        </div>
                    </div>
                </Popover >
            }
        </div>
    );
}